import { useQuery } from 'react-query';
import axios from 'axios';

import { Template, TemplatesByTenant } from '@/models/TemplatesByTenant';
import { useAuth } from '@/modules/Auth/hooks/useAuth';
import { AwsConfigApiGateway } from '@/utils/config/api';

import queryKeys from '../../modules/shared/query/queryKeys';

async function getTemplatesByTenant(token: string | undefined) {
  const response = await axios.get<TemplatesByTenant>(`${AwsConfigApiGateway.pooledTenantApiUrl}/templates`, {
    headers: {
      'x-api-key': AwsConfigApiGateway.pooledTenantApiKey,
      Authorization: 'Bearer ' + token,
    },
  });
  return response.data.data;
}

export function useGetTemplatesByTenant() {
  const { user } = useAuth();
  return useQuery<Template[]>({
    queryKey: [queryKeys.templates],
    queryFn: () => getTemplatesByTenant(user?.signInUserSession.idToken.jwtToken),
  });
}
